import { namespace } from './actions';
import { reportStep } from './actions';
import { cloneDeep, get, omit, isBoolean } from 'lodash';
import { daypartChartId, keywordReportTableId, reportItemType } from '../../../../pages/ReportBuilder/constants';
import { ACTION_TYPES } from './actions';
import { ComprehensiveReportConfig, CustomReportConfig, iHeartCustomReportConfig } from './initialConfig/CustomReportConfig';
import { defaultChartSelector } from '../../../../helpers/defaultInfo';
import { initialChartSelector, initialTableSortSelector } from './initialConfig/chartAndTable';
import { updateReportConfigByDateCompareHelper } from '../../../../components/DashboardTab/Report/helper';
import { initialSnapshots, initialSnapshotsAlphaMedia } from './initialConfig/snapshot';
import { overrideSnapShotConfig } from '../../../../helpers/common';
import { snapshotIdOfSimpleReport, trafficChannelsId } from './constant';
import { SimpleChartsAndTablesConfig, initialSimpleChartSelector } from './simpleReportConfig/simpleChartAndTable';
import { TRACKING_SOURCE_NAME } from '../../../../helpers/constant';
const { chartsAndTables, snapshots, userContactInfo, reportProperties } = CustomReportConfig;
const { chartsAndTables: iHeartChartsAndTables, chartSelector: iHeartChartSelector } = iHeartCustomReportConfig;
const { chartsAndTables: comprehensiveChartsAndTables, chartSelector: comprehensiveChartSelector } = ComprehensiveReportConfig;

const initialState = {
  template: reportItemType.all,
  snapshot: snapshots,
  chartAndTable: chartsAndTables,
  contactInfo: userContactInfo,
  reportProperties: reportProperties,
  currentStep: reportStep.detail,
  currentViewPage: 1,
  totalViewPage: 1,
  chartSelector: initialChartSelector,
  tableSortSelector: initialTableSortSelector,
  enableZeroState: true,
  haveUnSaveData: false,
  isTemplateModified: false,
};

function setReportConfigSessionStorage(reportConfig) {
  if (typeof(Storage) !== "undefined") {
    sessionStorage.setItem("reportConfig", JSON.stringify(reportConfig));
  }
}

function countTotalPage(currentChartAndTable) {
  let totalPage = 1;
  currentChartAndTable.forEach((chart => {
    chart.children.forEach(currentChild => {
      const isInCombo = currentChild.type === reportItemType.chart || currentChild.id === keywordReportTableId;
      const isDaypartParticular = currentChild.id.includes(daypartChartId) && currentChild.id !== daypartChartId;
      if (isInCombo && !isDaypartParticular) {
        const relativeChild = chart.children.find(relativeChild => relativeChild.id === currentChild.relativeId);
        const countLength = currentChild.count.filter((item, index) => item > 0 || get(relativeChild, ['count', index], 0) > 0).length;
        totalPage += countLength;
      }
    })
  }));
  return totalPage;
}

export default function reportReducer(state = initialState, action) {

  switch (action.type) {
    case ACTION_TYPES.UPDATE_SNAPSHOT_CONFIG: {
      const { id, value, isTemplateUpdatedInCustomizeStep } = action.payload;
      let isTemplateModified = false;
      if (isTemplateUpdatedInCustomizeStep) {
        isTemplateModified = isTemplateUpdatedInCustomizeStep;
      }
      const currentSnapshot = cloneDeep(state.snapshot);
      const updatedSnapshotIndex = currentSnapshot.findIndex(snapshot => snapshot.id === id);
      if (updatedSnapshotIndex !== -1) {
        if (isBoolean(value)) {
          currentSnapshot[updatedSnapshotIndex].showInReport = value;
          if (currentSnapshot[updatedSnapshotIndex].customOptions) {
            const newCustomOptions = currentSnapshot[
              updatedSnapshotIndex
            ].customOptions.map((option) => ({
              ...option,
              showInReport: value,
            }));
            currentSnapshot[
              updatedSnapshotIndex
            ].customOptions = newCustomOptions;
          }
        } else {
          currentSnapshot[updatedSnapshotIndex] = {
            ...currentSnapshot[updatedSnapshotIndex],
            ...value,
          };
        }
      }
      const reportConfig = {
        ...state,
        snapshot: currentSnapshot,
        haveUnSaveData: true,
        isTemplateModified,
      };
      setReportConfigSessionStorage(reportConfig);
      return reportConfig;
    }

    case ACTION_TYPES.UPDATE_CHART_AND_TABLE_CONFIG: {
      const { parentId, id, value, countIndex, isTemplateUpdatedInCustomizeStep } = action.payload;
      let isTemplateModified = false;
      if (isTemplateUpdatedInCustomizeStep) {
        isTemplateModified = isTemplateUpdatedInCustomizeStep;
      }
      const currentChartAndTable = cloneDeep(state.chartAndTable);
      const updatedChartAndTableIndex = currentChartAndTable.findIndex(chartAndTable => chartAndTable.id === parentId);
      if (updatedChartAndTableIndex !== -1) {
        const index = currentChartAndTable[updatedChartAndTableIndex].children.findIndex(item => item.id === id);
        if (index !== -1) {
          const currentItem = currentChartAndTable[updatedChartAndTableIndex].children[index];
          let currentCount = currentChartAndTable[updatedChartAndTableIndex].children[index].count;
          if(value) { // add chart/table to report
            const newItem = currentCount.length + 1;
            currentCount.push(newItem);
          } else if (countIndex !== undefined) { // delete chart/table from report with new logic
            currentCount.splice(countIndex, 1, 0);
          }
          const showInReport = currentCount.filter(item => item !== 0).length > 0;
          currentChartAndTable[updatedChartAndTableIndex].children[index] = { ...currentItem, showInReport, count: currentCount };
          if(value && currentItem.relativeId) { // add table of combo to report
            const relativeIndex = currentChartAndTable[updatedChartAndTableIndex].children.findIndex(item => item.id === currentItem.relativeId);
            const relativeItem = currentChartAndTable[updatedChartAndTableIndex].children[relativeIndex];
            const relativeCount = relativeItem.count;
            const newRelativeItem = relativeCount.length + 1;
            relativeCount.push(newRelativeItem);
            currentChartAndTable[updatedChartAndTableIndex].children[relativeIndex] = { ...relativeItem, showInReport: value, count: relativeCount};
          }
        }
      }
      const totalPage = countTotalPage(currentChartAndTable);
      const reportConfig = {
        ...state,
        chartAndTable: currentChartAndTable,
        totalViewPage: totalPage,
        haveUnSaveData: true,
        isTemplateModified,
      };
      setReportConfigSessionStorage(reportConfig);
      return reportConfig;
    }

    case ACTION_TYPES.UPDATE_REPORT_TEMPLATE: {
      //set isTemplateModified flag to false when new template selected
      const { type, trackingDataSourceName } = action.payload;

      let chartAndTable = type !== 'customReportSelect' ? cloneDeep(state.chartAndTable) : iHeartChartsAndTables;
      let chartSelector = type !== 'customReportSelect' ? cloneDeep(state.chartSelector) : iHeartChartSelector;
      
      if (type === reportItemType.simple) {
        chartAndTable = SimpleChartsAndTablesConfig
        chartSelector = initialSimpleChartSelector
      }

      if (type === reportItemType.comprehensive) {
        chartAndTable = comprehensiveChartsAndTables;
        chartSelector = comprehensiveChartSelector;
      }

      if (type !== 'customReportSelect' && type !== reportItemType.comprehensive) {
        chartAndTable.forEach(item => {
          return item.children.forEach(child => {
            const { selectorId } = child || {};
            // add default chart selector
            const oldChartSelector = chartSelector[selectorId] ? chartSelector[selectorId][0] : {};
            let addedChartSelector = {}
            if (type !== reportItemType.simple) {
              addedChartSelector = {
                ...oldChartSelector, // keep geo chart image
                ...defaultChartSelector[selectorId],
              }
              chartSelector[selectorId] = [addedChartSelector];
            }
            else {
              chartSelector[selectorId] = initialSimpleChartSelector[selectorId];
            }

            // don't change count and showInReport config of Daypart chart items other than the first Daypart chart
            const isAbleToUpdate = !(child.id.includes('daypartAnalyticsChart') && child.id !== 'daypartAnalyticsChart');
            //each time a report template is selected the count will reset
            if (type === reportItemType.all){
              if (isAbleToUpdate) {
                child.showInReport = true;
                child.count = [1];
              }
            } else if (type !== reportItemType.simple) {
              if (child.type === type) {
                if (isAbleToUpdate) {
                  child.showInReport = true;
                  child.count = [1];
                }
              } else {
                //this logic will also apply to template type `emptyReportSelect`
                child.showInReport = false;
                child.count = [0];
                if (type === reportItemType.none) {
                  chartSelector[selectorId] = [];
                  child.count = [];
                }
              }
            }
          })
        })
      }

      let snapshot = cloneDeep(state.snapshot);
      snapshot.forEach(item => {
        if (type === reportItemType.table){
          item.showInReport = false;
        } else {
          item.showInReport = true;

          if (type === reportItemType.simple && !snapshotIdOfSimpleReport.includes(item.id)) {
            item.showInReport = false;
          }
          if(type === reportItemType.none){
            item.showInReport = false;
          }
          if (item.customOptions) {
            item.customOptions = item.customOptions.map((option) => ({
              ...option,
              showInReport: true,
            }));
          }
        }
      })
      
      if (trackingDataSourceName ===  TRACKING_SOURCE_NAME.PIXEL) {
        chartAndTable = chartAndTable.filter((item) => item.id !== trafficChannelsId);
      }

      const totalPage = countTotalPage(chartAndTable);
      const reportConfig = {
        ...state,
        template: type,
        chartAndTable,
        snapshot,
        totalViewPage: totalPage, 
        haveUnSaveData: true,
        chartSelector,
        isTemplateModified: false,
      }
      setReportConfigSessionStorage(reportConfig);
      return reportConfig;
    }

    case ACTION_TYPES.UPDATE_USER_CONTACT_INFO_CONFIG_BY_KEY: {
      const { key, value } = action.payload;
      const reportConfig = {
        ...state,
        contactInfo: {
          ...state.contactInfo,
          [key]: value,
        },
        haveUnSaveData: true,
      }
      setReportConfigSessionStorage(reportConfig);
      return reportConfig;
    }

    case ACTION_TYPES.UPDATE_REPORT_PROPERTIES_CONFIG: {
      const { reportProperties } = action.payload;
      const reportConfig = {
        ...state,
        reportProperties,
        haveUnSaveData: true,
      };
      setReportConfigSessionStorage(reportConfig);
      return reportConfig;
    }

    case ACTION_TYPES.UPDATE_REPORT_PROPERTIES_CONFIG_BY_KEY: {
      const {key, value, isUpdateDate} = action.payload;
      let haveUnSaveData = isUpdateDate;
      // avoid updating haveUnSaveData at the first time rendering report date range
      if (key !== 'reportDateRange') {
        haveUnSaveData = true;
      }
      const reportConfig = {
        ...state,
        reportProperties: {
          ...state.reportProperties,
          [key]: value,
        },
        haveUnSaveData,
      }
      setReportConfigSessionStorage(reportConfig);
      return reportConfig;
    }

    case ACTION_TYPES.UPDATE_REPORT_CONFIG_BY_KEY: {
      const {key, value} = action.payload;
      let haveUnSaveData = true;
      if (key === 'haveUnSaveData') {
        haveUnSaveData = value;
      }
      // don't change haveUnSaveData state when changing step
      if (key === 'currentStep' || key === 'currentViewPage') {
        haveUnSaveData = state.haveUnSaveData;
      }
      const reportConfig = {
        ...state,
        [key]: value,
        haveUnSaveData,
      }
      setReportConfigSessionStorage(reportConfig);
      return reportConfig;
    }

    case ACTION_TYPES.RESET_REPORT_CONFIG: {
      setReportConfigSessionStorage({
        ...initialState,
      });
      return {
        ...initialState,
      };
    }

    case ACTION_TYPES.GET_REPORT_CONFIG: {
      let reportConfig = {...initialState};
      if (typeof(Storage) !== "undefined") {
        reportConfig = JSON.parse(sessionStorage.getItem("reportConfig")) || {...initialState};
      }
      return {
        ...reportConfig,
        haveUnSaveData: get(reportConfig, 'haveUnSaveData', state.haveUnSaveData),
      }
    }

    case ACTION_TYPES.SET_REPORT_BUILDER_DATA: {
      const { reportBuilder } = action.payload;
      // not use haveUnSaveData from DB
      const builderReportConfig = {
        ...omit(reportBuilder, ['haveUnSaveData']),
      }
      // override maximum of chart/table config when editing report
      const newChartAndTable = (builderReportConfig.chartAndTable || []).map(config => {
        const defaultChildren = (chartsAndTables.find(item => item.id === config.id) || {}).children || [];
        const newChildren = config.children.map(child => {
          const defaultChild = defaultChildren.find(item => item.id === child.id) || {};
          return {
            ...defaultChild,
            ...child,
            max: defaultChild.max,
          }
        })
        return {
          ...config,
          children: newChildren,
        }
      })
      // override snapshot config for existing report
      const snapshotConfig = builderReportConfig.snapshot;
      const newSnapshotConfig = overrideSnapShotConfig({ reportBuilderSnapshot: initialSnapshots, snapshot: snapshotConfig });

      const reportConfig = {
        ...builderReportConfig,
        chartAndTable: newChartAndTable,
        totalViewPage: countTotalPage(newChartAndTable),
        snapshot: newSnapshotConfig,
      }
      setReportConfigSessionStorage(reportConfig);
      return reportConfig;
    }

    case ACTION_TYPES.SET_REPORT_CHART_SELECTOR: {
      const { chartId, chartIndex, updatedSelector } = action.payload;
      const currentChartSelector = cloneDeep(state.chartSelector);
      currentChartSelector[chartId][chartIndex] = { ...currentChartSelector[chartId][chartIndex], ...updatedSelector };
      const currentTableSortSelector = cloneDeep(state.tableSortSelector);
      // reset table sort selector when changing chart selector except when saving geo map image
      let haveUnSaveData = true;
      let isTemplateModified = true;
      if (!(updatedSelector || {}).imageForGeoChart) {
        currentTableSortSelector[chartId] = {
          ...currentTableSortSelector[chartId],
          [chartIndex]: undefined,
        };
      } else {
        // don't change haveUnSaveData state or isTemplateModified state if store geoChart image
        haveUnSaveData = state.haveUnSaveData;
        isTemplateModified = state.isTemplateModified;
      }
      const reportConfig = {
        ...state,
        chartSelector: currentChartSelector,
        tableSortSelector: currentTableSortSelector,
        haveUnSaveData,
        isTemplateModified,
      }
      setReportConfigSessionStorage(reportConfig);
      return reportConfig;
    }

    case ACTION_TYPES.ADD_DEFAULT_CHART_SELECTOR: {
      const { chartId, chartSelector } = action.payload;
      const currentChartSelector = cloneDeep(state.chartSelector);
      if (chartId) {
        const addedChartSelector = chartSelector || defaultChartSelector[chartId];
        currentChartSelector[chartId].push(addedChartSelector);
      }
      const reportConfig = {
        ...state,
        chartSelector: currentChartSelector,
        haveUnSaveData: true,
      }
      setReportConfigSessionStorage(reportConfig);
      return reportConfig;
    }

    case ACTION_TYPES.SET_TABLE_SORT_SELECTOR: {
      const { tableId, tableIndex, sortSelector } = action.payload;
      const currentTableSortSelector = cloneDeep(state.tableSortSelector);
      if (tableId) {
        currentTableSortSelector[tableId] = {
          ...currentTableSortSelector[tableId],
          [tableIndex]: sortSelector,
        };
      }
      const reportConfig = {
        ...state,
        tableSortSelector: currentTableSortSelector,
        haveUnSaveData: true,
        isTemplateModified: true,
      }
      setReportConfigSessionStorage(reportConfig);
      return reportConfig;
    }

    case ACTION_TYPES.SET_ALL_DEFAULT_REPORT_SELECTOR: {
      const { chartSelector, tableSortSelector } = action.payload;
      const reportConfig = {
        ...state,
        chartSelector,
        haveUnSaveData: true,
      }
      if (tableSortSelector) {
        reportConfig.tableSortSelector = tableSortSelector;
      }
      setReportConfigSessionStorage(reportConfig);
      return reportConfig;
    }

    case ACTION_TYPES.UPDATE_REPORT_CONFIG_BY_DATE_COMPARE: {
      const { updatingConfigFields } = action.payload;
      const currentChartAndTable = cloneDeep(state.chartAndTable);
      const { chartAndTable } = updateReportConfigByDateCompareHelper({
        updatingConfigFields,
        chartAndTable: currentChartAndTable,
      });
      const totalViewPage = countTotalPage(chartAndTable);
      const reportConfig = {
        ...state,
        chartAndTable,
        totalViewPage,
        haveUnSaveData: true,
      };
      setReportConfigSessionStorage(reportConfig);
      return reportConfig;
    }

    case ACTION_TYPES.UPDATE_INITIAL_SNAP_SHOT_BY_ALPHA_MEDIA: {
      const { reportBuilderSnapshot } = action.payload;

      const newSnapshotConfig = overrideSnapShotConfig({ reportBuilderSnapshot: initialSnapshotsAlphaMedia, snapshot: reportBuilderSnapshot, isShowAlphaMediaDashboardUI: true});

      const reportConfig = {
        ...state,
        snapshot: newSnapshotConfig,
      }
      setReportConfigSessionStorage(reportConfig);
      return reportConfig;
    }

    default:
      return state;
  }
}

export { namespace };

export const getReportDateRange = (state) => get(state, [namespace, 'reportProperties', 'reportDateRange']);
